export const state = {
  modalitiesLocalTrainings: [],
  filteredArray: [],
  localTrainings: [],
  modalities: []
}
